import { render, staticRenderFns } from "./ReportPlasticCompoment.vue?vue&type=template&id=5899ff47&scoped=true"
import script from "./ReportPlasticCompoment.vue?vue&type=script&lang=js"
export * from "./ReportPlasticCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899ff47",
  null
  
)

export default component.exports